import { TFunction } from "i18next";
import { number, object, ref, string } from "yup";

export const profileSchema = (t: TFunction) =>
  object({
    email: string()
      .email(t("profile.notValidEmail"))
      .max(180, t("profile.longEmail")),
    companyEmail: string()
      .email(t("profile.notValidEmail"))
      .max(180, t("profile.longEmail")),
    firstName: string().max(255, t("profile.longFirstName")),
    lastName: string().max(255, t("profile.longLastName")),
    phone: string()
      .required(t("profile.phoneRequired"))
      .min(10, t("profile.shortPhone"))
      .matches(/^\+?[1-9]\d{1,14}$/, t("profile.invalidPhone")),
    password: string()
      .min(6, t("profile.shortPassword"))
      .max(255, t("profile.longPassword")),
    passwordConfirmed: string().when("password", {
      is: (val: string) => val && val.length > 0,
      then: (schema) =>
        schema
          .required(t("profile.matchPasswords"))
          .oneOf([ref("password")], t("profile.matchPasswords")),
      otherwise: (schema) =>
        schema.oneOf([ref("password"), null], t("profile.matchPasswords")),
    }),
    countryId: number(),
    companyWebsite: string()
      .url(t("profile.Url is not valid"))
      .matches(
        /^(https?:\/\/)/,
        "profile.Url must start with http:// или https://"
      )
      .max(2048, t("profile.Url is too long")),
  });
